const locale: Locale = {
  ko: {
    fill: '제목 또는 내용을 작성해주세요.',

    title: '제목',
    category: '분류',
    select: '카테고리를 선택해주세요.',
    description: '내용',

    cancle: '작성 취소',
    complete: '작성 완료',
  },
  en: {
    fill: 'Please fill in the title or description.',

    title: 'Title',
    category: 'Category',
    select: 'Select Category',
    description: 'Description',

    cancle: 'Cancle',
    complete: 'Submit',
  },
}

export default locale
